/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询票夹列表数量
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetTicketFolderNumParams {
  constructor(public memberId: string, public theaterId: string) {}
}

export default async function (
  params: GetTicketFolderNumParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.TicketFolderDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/ticket-folder/listNum`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
